module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAQCAYAAAABOs/SAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHVJREFUeNrE1UsOwCAIRVF9cQusV9eri2g16aCxP0Wgd0CYkDPE55wds9QGESXOcVhAY1tKKSwcK+hRrLg63KNsHAIoC4cQOo1DEJ3CIYwO41BAh3AooZ84FNFXHMroIw4D9BaHEXrBgyF6xp2vb3FzP7QLMACPT0mPsuoS/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-arrow-up.png
// module id = 739
// module chunks = 0